import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import App from './App';
import Layout from "./components/Layout";
import {LikedProduct, PopularItems} from './components/StockImages';
import NotFound from './components/NotFound';
import Profile from './components/Profile';
import {Product, ProductsForMen, ProductsForWomen, ShoesProductsForMen, ShoesProductsForWomen, WalletsProductsForMen, WalletsProductsForWomen, ClothesProductsForMen, ClothesProductsForWomen, Jewellery, Glasses, Watches, PerfumesForMen, PerfumesForWomen, BagsForMen, BagsForWomen, LoafersForMen, SneakersForMen, SlidesForMen, YeezysForMen, MessengersForMen, DufflesForMen, BackPacksForMen, SlingsForMen, SatchelsForMen, BeltBagsForMen, EspadrillesForWomen, SneakersForWomen, SlidesForWomen, HeelsForWomen, SandalsForWomen, TotesForWomen, ShoulderCrossBodyForWomen, MiniBagsForWomen, ClutchesForWomen, Unisex } from './components/Single';
import GetAllItems from './components/GetAllItems';
import reportWebVitals from './reportWebVitals';
import ProductsProvider from './context/ProductsProvider'; 
import AuthProvider, { useAuthContext } from './context/AuthContext';
import { CategorySlideForMen, CategoryForWomen } from './components/List';
import UpdateProductForm from './components/UpdateProductForm';
import UpdateImgForm from "./components/UpdateImgForm";
function AppRoutes() {
  const { currentUser } = useAuthContext()
  return(
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/product/:id" element={<Product />} />

      {/** Men Calegory*/}
      <Route path="/categoryUnisex" element={<Unisex />} />
      <Route path="/categoryForMen" element={<CategorySlideForMen />} />
      <Route path="/categoryForWomen" element={<CategoryForWomen />} />
      
      <Route path="/shoesProductsForMen" element={<ShoesProductsForMen />} />
      <Route path="/shoesProductsForWomen" element={<ShoesProductsForWomen />} />
      <Route path="/walletsProductsForMen" element={<WalletsProductsForMen />} />
      <Route path="/walletsProductsForWomen" element={<WalletsProductsForWomen />} />
      <Route path="/clothesproductsformen" element={<ClothesProductsForMen />} />
      <Route path="/clothesproductsforwomen" element={<ClothesProductsForWomen />} />
      <Route path="/jewellery" element={<Jewellery />} />
      <Route path="/glasses" element={<Glasses />} />
      <Route path="/watches" element={<Watches />} />
      <Route path="/perfumesformen" element={<PerfumesForMen />} />
      <Route path="/perfumesforwomen" element={<PerfumesForWomen />} />
      <Route path="/bagsformen" element={<BagsForMen />} />
      <Route path="/bagsforwomen" element={<BagsForWomen />} />

      {/** Shoes Subcategory For Men */}
      <Route path="/loafers-for-men" element={<LoafersForMen />} />
      <Route path="/sneakers-for-men" element={<SneakersForMen />} />
      <Route path="/slides-for-men" element={<SlidesForMen />} />
      <Route path="/yeezys-for-men" element={<YeezysForMen />} />
      
      {/** Bags Subcategory For Men */}
      <Route path="/messengers-for-men" element={<MessengersForMen />} />
      <Route path="/duffles-for-men" element={<DufflesForMen />} />
      <Route path="/back-packs-for-men" element={<BackPacksForMen />} />
      <Route path="/slings-for-men" element={<SlingsForMen />} />
      <Route path="/satchels-for-men" element={<SatchelsForMen />} />
      <Route path="/belt-bags-for-men" element={<BeltBagsForMen />} />

      {/** Shoes Subcategory For Women */}
      <Route path="/espadrilles-for-women" element={<EspadrillesForWomen />} />
      <Route path="/sneakers-for-women" element={<SneakersForWomen />} />
      <Route path="/slides-for-women" element={<SlidesForWomen />} />
      <Route path="/heels-for-women" element={<HeelsForWomen />} />
      <Route path="/sandals-for-women" element={<SandalsForWomen />} />

      {/** Bags Subcategory For Women */}
      <Route path="/totes-for-women" element={<TotesForWomen />} />
      <Route path="/shoulder-cross-body-for-women" element={<ShoulderCrossBodyForWomen />} />
      <Route path="/mini-bags-for-women" element={<MiniBagsForWomen />} />
      <Route path="/clutches-for-women" element={<ClutchesForWomen />} />

      <Route path="/products-men" element={<ProductsForMen />} />
      <Route path="/products-women" element={<ProductsForWomen />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="*" element={<NotFound />} />
      
      {currentUser && <Route path="/stockimages" element={<LikedProduct />} />}
      {currentUser && <Route path="/update-item" element={<PopularItems />} />}
      {currentUser && <Route path="/get-all-items" element={<GetAllItems />} />}
      {currentUser && <Route path="/update-product-form/:id" element={<UpdateProductForm />} />}
      {currentUser && <Route path="/update-product-img/:id" element={<UpdateImgForm />} />}
    </Routes>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ProductsProvider>
        <Router>
          <Layout>
            <AppRoutes />
          </Layout>
        </Router>
      </ProductsProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

